import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import OSM from 'ol/source/OSM';
import { formatoPNG } from './configuracion'

//const capaBase01 = new TileLayer({title: 'Water color', type: 'base', visible: false, source: new Stamen({layer: 'watercolor'})});
const capaBase02 = new TileLayer({title: 'OSM', type: 'base', visible: true, source: new OSM()});
const capaBase03 = new TileLayer({title: 'PNOA', type: 'base', visible: false, source: new TileWMS({url: 'http://www.ign.es/wms-inspire/pnoa-ma', params: {LAYERS: 'OI.OrthoimageCoverage', FORMAT: formatoPNG}, attributions: '<a href="https://cartosig.webs.upv.es"><img src="logoejemplo.jpg"/></a>Instituto Geográfico Nacional <a href="https://www.ign.es">IGN</a>',})});

export const grupoBase01 = new LayerGroup({
  title: 'Capas base',
  fold: 'open',
  layers: [capaBase02, capaBase03]
});